import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import UnstyledButton from '@components/UI/UnstyledButton';
import { css } from '@emotion/react';
import { InfoModal } from 'vl-common/src/components/Modals';

const SendGDPREmailFormItem = ({
  needsGDPREmailSending,
  sendGDPREmail,
  GDPRConfirmationSent
}: {
  needsGDPREmailSending: boolean;
  sendGDPREmail: () => void;
  GDPRConfirmationSent: boolean;
}) => {
  const [showGDPRInformation, setShowGDPRInformation] = useState(false);
  const { t } = useTranslation('common');

  return (
    <>
      <InfoModal
        open={showGDPRInformation}
        closable
        onCancel={() => setShowGDPRInformation(false)}
        onOk={() => setShowGDPRInformation(false)}
        cancelButtonProps={{ style: { display: 'none' } }}
        title={`${t('Patient GDPR')} ${t('General Information')}`}
      >
        {t('Gdpr Information')}
      </InfoModal>

      {needsGDPREmailSending && (
        <Row>
          <Col span={14}>
            <Form.Item
              name="SendGDPREmail"
              label={
                <>
                  <UnstyledButton
                    type="button"
                    className="gdpr-info-button"
                    data-testid="gdpr-info-button"
                    css={css`
                      cursor: pointer;
                      vertical-align: middle;
                      font-size: 18px;
                      margin-right: 5px;
                    `}
                  >
                    <AiOutlineInfoCircle onClick={() => setShowGDPRInformation(true)} />
                  </UnstyledButton>
                  {t('Send GDPR email to patient')}
                </>
              }
              labelCol={{ span: 18 }}
            >
              <></>
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item>
              <Button
                data-testid="send-gdpr-email-button"
                css={{ float: 'right' }}
                type="link"
                size="small"
                disabled={!needsGDPREmailSending}
                onClick={sendGDPREmail}
              >
                {GDPRConfirmationSent ? t('Resend') : t('Send')} {t('GDPR email')}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      )}
    </>
  );
};

export default SendGDPREmailFormItem;
